<template>
  <div>
    <Header />
    <el-card v-if="status === false" style="max-width: 600px; margin: 0 auto; margin-top: 50px"
      header="Recuperación de contraseña">
      <el-form label-position="top" label-width="100px">
        <el-form-item label="Nombre de usuario">
          <el-input v-model="user.rut"></el-input>
        </el-form-item>
        <el-form-item label="Correo electrónico">
          <el-input v-model="user.email"></el-input>
        </el-form-item>
      </el-form>
      <center>
        <el-button @click="regresar" type="info" icon="el-icon-back">Regresar</el-button>
        <el-button @click="validData" type="primary" icon="el-icon-refresh">Recuperar Contraseña</el-button>
      </center>
    </el-card>
    <el-card v-if="status === true && status_codigo === false" style="max-width: 600px; margin: 0 auto; margin-top: 50px"
      header="Validación del código">
      <small style="color: red">(*) Un código ha sido enviado al correo electrónico
        {{ user.email }}</small>
      <el-form label-position="top" label-width="100px">
        <el-form-item label="Ingrese su código aquí">
          <el-input v-model="new_codigo"></el-input>
        </el-form-item>
      </el-form>
      <br />
      <center>
        <el-button @click="regresar" type="info" icon="el-icon-back">Regresar</el-button>
        <el-button @click="validCode" type="primary" icon="el-icon-refresh">Validar código</el-button>
      </center>
    </el-card>
    <el-card v-if="status === true && status_codigo === true" style="max-width: 600px; margin: 0 auto; margin-top: 50px"
      header="Ingresar nueva contraseña">
      <el-form style="margin-top: 15px" label-position="top" label-width="100px">
        <el-form-item label="Contraseña">
          <el-input type="password" v-model="password" :keyup="validPass(password)"></el-input>
        </el-form-item>
        <el-form-item label="Repita su Contraseña">
          <el-input type="password" v-model="password_repeat"></el-input>
        </el-form-item>
        <span><el-icon v-if="pass_1" style="color: green" class="el-icon-success"></el-icon><el-icon v-else
            style="color: red" class="el-icon-error"></el-icon>
          Longitud mínima 8</span><br />
        <span><el-icon v-if="pass_2" style="color: green" class="el-icon-success"></el-icon><el-icon v-else
            style="color: red" class="el-icon-error"></el-icon>
          Longitud máxima 100</span><br />
        <span><el-icon v-if="pass_3" style="color: green" class="el-icon-success"></el-icon><el-icon v-else
            style="color: red" class="el-icon-error"></el-icon>
          Debe tener letras mayúsculas</span><br />
        <span><el-icon v-if="pass_4" style="color: green" class="el-icon-success"></el-icon><el-icon v-else
            style="color: red" class="el-icon-error"></el-icon>
          Debe tener letras minúsculas</span><br />
        <span><el-icon v-if="pass_5" style="color: green" class="el-icon-success"></el-icon><el-icon v-else
            style="color: red" class="el-icon-error"></el-icon>
          Debe tener al menos 2 dígitos</span><br />
        <span><el-icon v-if="pass_6" style="color: green" class="el-icon-success"></el-icon><el-icon v-else
            style="color: red" class="el-icon-error"></el-icon>
          No debe tener espacios</span>
      </el-form>
      <center>
        <br />
        <el-button @click="regresar" type="info" icon="el-icon-back">Regresar</el-button>
        <el-button @click="setPassword" type="primary" icon="el-icon-refresh">Cambiar Contraseña</el-button>
      </center>
    </el-card>
    <br>
    <center>
      <el-button @click="dialogTutorial = true" type="danger" icon="el-icon-video-play">Video Tutorial cómo cambiar contraseña</el-button>
    </center>

    <el-dialog title="Cómo cambiar contraseña" :visible.sync="dialogTutorial" width="40%" :before-close="handleClose">
      <div style="max-width: 600px; margin: 0 auto; margin-top: 50px">
        <iframe width="100%" height="315" src="https://www.youtube.com/embed/YsAhjGAtlco?si=PdODviMVwUQf0VPY"
          title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen></iframe>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="dialogTutorial = false">Cerrar Video Tutorial</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Header from "../components/Header.vue";

export default {
  data() {
    return {
      dialogTutorial: false,
      pass_1: false,
      pass_2: false,
      pass_3: false,
      pass_4: false,
      pass_5: false,
      pass_6: false,
      password: "",
      password_repeat: "",
      new_codigo: "",
      codigo: "",
      status_codigo: false,
      status: false,
      user: {
        rut: "",
        email: "",
      },
    };
  },
  components: {
    Header,
  },
  methods: {
    regresar() {
      this.handleClose();
      this.$router.push({ name: "homePage" });
    },
    handleClose() {
      this.user = {
        rut: "",
        email: "",
      };
      this.new_codigo = "";
      this.codigo = "";
      this.status_codigo = false;
      this.status = false;
      this.password = "";
      this.password_repeat = "";
      this.pass_1 = false;
      this.pass_2 = false;
      this.pass_3 = false;
      this.pass_4 = false;
      this.pass_5 = false;
      this.pass_6 = false;
      this.dialogTutorial = false;
    },
    setPassword() {
      if (this.password !== this.password_repeat) {
        this.$alert(
          "Las contraseñas ingresadas no coinciden",
          "Información importante",
          {
            type: "error",
            confirmButtonText: "Aceptar",
            callback: (action) => { },
          }
        );
      } else {
        var passwordValidator = require("password-validator");

        // Create a schema
        var schema = new passwordValidator();

        // Add properties to it
        schema
          .is()
          .min(8) // Minimum length 8
          .is()
          .max(100) // Maximum length 100
          .has()
          .uppercase() // Must have uppercase letters
          .has()
          .lowercase() // Must have lowercase letters
          .has()
          .digits(2) // Must have at least 2 digits
          .has()
          .not()
          .spaces() // Should not have spaces
          .is()
          .not()
          .oneOf([]); // Blacklist these values

        if (schema.validate(this.password)) {
          this.updatePassword();
        } else {
          this.$alert(
            "La contraseña ingresada no cumple con los requisitos solicitados",
            "Información importante",
            {
              type: "error",
              confirmButtonText: "Aceptar",
              callback: (action) => { },
            }
          );
        }
      }
    },
    async updatePassword() {
      const response = await axios.post(`/usuarios/changePassword`, {
        codigo: this.new_codigo,
        passwd: this.password,
      });
      if (response.data.status === true) {
        this.$alert(response.data.message, "Información importante", {
          type: "success",
          confirmButtonText: "Aceptar",
          callback: (action) => {
            this.handleClose();
            this.$router.push({ name: "homePage" });
          },
        });
      } else {
        this.$alert(response.data.message, "Información importante", {
          type: "warning",
          confirmButtonText: "Aceptar",
          callback: (action) => {
            this.handleClose();
          },
        });
      }
    },
    validPass(pass) {
      // minimo de 8
      if (pass.length >= 8) {
        this.pass_1 = true;
      } else {
        this.pass_1 = false;
      }
      // maximo de 100
      if (pass.length <= 100) {
        this.pass_2 = true;
      } else {
        this.pass_2 = false;
      }
      // mayusculas
      if (this.tiene_mayusculas(pass) === true) {
        this.pass_3 = true;
      } else {
        this.pass_3 = false;
      }
      // minusculas
      if (this.tiene_minusculas(pass) === true) {
        this.pass_4 = true;
      } else {
        this.pass_4 = false;
      }
      // minimo dos numeros
      if (this.getNumbersInString(pass).length >= 2) {
        this.pass_5 = true;
      } else {
        this.pass_5 = false;
      }
      // sin espacios
      var noValido = / /;
      if (noValido.test(pass)) {
        this.pass_6 = false;
      } else {
        this.pass_6 = true;
      }
    },
    getNumbersInString(string) {
      var tmp = string.split("");
      var map = tmp.map(function (current) {
        if (!isNaN(parseInt(current))) {
          return current;
        }
      });

      var numbers = map.filter(function (value) {
        return value != undefined;
      });

      return numbers.join("");
    },
    tiene_minusculas(texto) {
      var letras = "abcdefghyjklmnñopqrstuvwxyz";
      for (var i = 0; i < texto.length; i++) {
        if (letras.indexOf(texto.charAt(i), 0) != -1) {
          return true;
        }
      }
      return false;
    },
    tiene_mayusculas(texto) {
      var letras_mayusculas = "ABCDEFGHYJKLMNÑOPQRSTUVWXYZ";
      for (var i = 0; i < texto.length; i++) {
        if (letras_mayusculas.indexOf(texto.charAt(i), 0) != -1) {
          return true;
        }
      }
      return false;
    },
    validCode() {
      var sha1 = require("sha1");
      if (this.codigo === sha1(this.new_codigo)) {
        this.status_codigo = true;
      } else {
        this.$alert(
          "El código ingresado no es válido",
          "Información importante",
          {
            type: "info",
            confirmButtonText: "Aceptar",
            callback: (action) => { },
          }
        );
      }
    },
    async validData() {
      if (this.user.rut === "" || this.user.email === "") {
        this.$alert(
          "Debes completar toda la información solicitada para continuar",
          "Información importante",
          {
            type: "info",
            confirmButtonText: "Aceptar",
            callback: (action) => { },
          }
        );
        return;
      }
      const response = await axios.post(`/inventarios/recoveryPassword`, {
        rut: this.user.rut,
        email: this.user.email,
      });
      if (response.data.status === true) {
        this.codigo = response.data.codigo;
        this.status = response.data.status;
      } else {
        this.$alert(response.data.message, "Información importante", {
          type: "info",
          confirmButtonText: "Aceptar",
          callback: (action) => { },
        });
      }
    },
  },
};
</script>

<style scoped></style>